var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoldChair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 142,
    viewBox: "0 0 143 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.055 70.9999C141.055 109.435 109.909 140.58 71.4745 140.58C33.0399 140.58 1.89453 109.435 1.89453 70.9999C1.89453 32.5653 33.0399 1.41992 71.4745 1.41992C109.909 1.41992 141.055 32.5653 141.055 70.9999Z",
    fill: "url(#paint0_linear_1545_9248)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.4735,
    cy: 70.9999,
    r: 61.3872,
    stroke: "#FFC25D",
    strokeWidth: 4.07895
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.573 46.1794C103.599 46.3125 103.622 46.4299 103.656 46.5139C103.722 46.679 103.19 51.6148 102.552 57.5294C101.641 65.9774 100.516 76.422 100.61 77.8127C100.61 79.8165 99.4076 102.339 99.0068 109.472C98.9267 110.674 97.9248 111.636 96.7225 111.636H96.2016C94.9191 111.636 93.9173 110.594 93.9173 109.352C93.9173 103.661 93.8371 88.9938 92.9955 83.9843C92.2742 79.8566 90.3105 78.8547 87.8258 78.7746L86.5835 100.014C86.5033 101.217 85.5014 102.179 84.2992 102.179C83.0969 102.179 82.0951 101.257 82.0149 100.055L80.6523 79.2555C78.7975 79.378 77.7143 79.5234 76.7089 79.6583C75.4118 79.8325 74.2441 79.9892 71.7155 80.057H71.6354C68.9674 79.9855 67.7154 79.8291 66.255 79.6466C65.2584 79.5221 64.1648 79.3855 62.4581 79.2555L61.0956 100.055C61.0154 101.257 60.0135 102.179 58.8113 102.179C57.609 102.179 56.6071 101.217 56.527 100.014L55.2847 78.7746C52.8 78.8948 50.8363 79.8566 50.1149 83.9843C49.2333 88.9938 49.1932 103.661 49.1932 109.352C49.1932 110.634 48.1513 111.636 46.9089 111.636H46.3879C45.1857 111.636 44.1838 110.674 44.1036 109.472C43.9972 107.367 43.814 103.922 43.6086 100.06C43.118 90.8334 42.5006 79.2252 42.5006 77.8127C42.5006 76.5596 41.555 67.9554 40.69 60.0847C39.9229 53.1051 39.2193 46.7023 39.2946 46.5139C39.3282 46.4299 39.3512 46.3125 39.3774 46.1794C39.4759 45.6771 39.6183 44.951 40.5369 44.951H44.1437C44.1437 44.951 45.4662 44.0293 47.9509 37.0562C50.3436 30.3026 59.2769 30.3499 61.6886 30.3626C61.7814 30.3631 61.8645 30.3636 61.9372 30.3636H81.2935C81.3665 30.3636 81.4496 30.3631 81.542 30.3626C83.936 30.3499 92.607 30.3036 94.9993 37.0562C97.484 44.0293 98.8064 44.951 98.8064 44.951H102.413C103.332 44.951 103.474 45.6771 103.573 46.1794ZM58.5308 67.8741L60.254 40.4225C60.4143 38.3386 59.3723 36.3749 56.5671 37.4569C54.7853 38.1442 53.8442 40.3187 52.8505 42.6149C52.2796 43.934 51.6914 45.2933 50.9165 46.4338C49.3134 48.9585 49.073 49.0387 47.8707 49.239C44.5846 49.3192 45.0655 51.884 45.0655 51.884C46.7486 69.6374 53.321 68.7958 53.321 68.7958H56.8075C58.5708 68.8359 58.5308 67.8741 58.5308 67.8741ZM68.3492 57.9354C68.6698 57.9354 68.9103 57.6949 68.9103 57.3743V42.1457C68.9103 41.8251 68.6698 41.5847 68.3492 41.5847C68.0286 41.5847 67.7882 41.8251 67.7882 42.1457V57.3743C67.7882 57.6949 68.0286 57.9354 68.3492 57.9354ZM74.9216 57.9354C75.2422 57.9354 75.4826 57.6949 75.4826 57.3743V42.1457C75.4826 41.8251 75.2422 41.5847 74.9216 41.5847C74.601 41.5847 74.3605 41.8251 74.3605 42.1457V57.3743C74.3605 57.6949 74.601 57.9354 74.9216 57.9354ZM89.6292 68.7958C89.6292 68.7958 96.2416 69.5973 97.8847 51.884C97.8847 51.884 98.3656 49.3192 95.0794 49.239C93.8772 49.0387 93.6367 48.9585 92.0337 46.4338C91.1538 45.1388 90.7141 43.5619 90.3014 42.0819C89.7179 39.9894 89.1884 38.0907 87.5453 37.4569C84.74 36.3749 83.658 38.3786 83.8183 40.4225L85.5415 67.8741C85.5415 67.8741 85.5014 68.8359 87.2648 68.7958H89.6292ZM71.5956 68.8359C79.8511 68.8359 80.5724 68.6756 80.5724 68.4752C80.5724 68.2748 79.8912 68.1145 71.5956 68.1145C63.3401 68.1145 62.3382 68.2748 62.3382 68.4752C62.3382 68.6756 63.3401 68.8359 71.5956 68.8359Z",
    fill: "#FFC25D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9248",
    x: 8.04688,
    y: 7.57324,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9248"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9248",
    x: 39.2891,
    y: 30.3613,
    width: 64.3711,
    height: 82.9065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9248",
    x1: 23.1945,
    y1: 16.5666,
    x2: 124.725,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoldChair);
export default __webpack_public_path__ + "static/media/IconGoldChair.d60b90bc1ff37358b369c648391990f8.svg";
export { ForwardRef as ReactComponent };